import type { IIssueRepository, IssueStats, IssueStatsOptions } from '../repositories/IIssueRepository.js';

interface Deps { issueRepository: IIssueRepository; }

export function createGetIssueStatsUseCase({ issueRepository }: Deps) {
  return async function getIssueStats(options: IssueStatsOptions): Promise<IssueStats> {
    return issueRepository.stats(options);
  };
}
